import {
  PROJECT,
  IMPORT_SERVICES,
  SET_VEHICLES,
  SET_VEHICLE_TYPES,
  SET_DRIVERS,
  SELECTED_ROUTES,
  EXPANDED_ROUTES,
  PROJECT_OPTIONS,
  PUBLICATION_SETTINGS,
  SET_DRIVER_LOCATIONS,
  CLEAR_DRIVER_LOCATIONS,
  LOCKED_ROUTES,
  SELECTED_VEHICLES,
  SET_CURRENT_WINDOW,
  CHANGED_VEHICLES,
  RESET_STATE,
  SET_PROJECT_DETAILS,
  SET_DRIVER_LIVE,
  EXPANDED_FROM_MAP,
  SET_PROJECT_STARTED,
  SET_SHOWING_ROUTE_ID,
  UPDATE_ROUTES_ETAS
} from "./types";

import API from "../../utils/axios";
import {
  setLoadingProject,
  setVehiclesListLoaded,
  setDriversListLoaded,
  setInitialProjectLoading,
  setDeterminateLoading
} from "./loading";
import { setExtendableId, setExtendableType } from "./edit";
import { setDragSelection, setInfoDialog } from "./common";
import { enqueueSnackbar } from "./snackbars";
import history from "../../utils/history";
import { arraysEqual } from "../../utils/helpers";
import {
  checkFor401,
  getFormattedRoutes,
  getRouteColors
} from "./actionHelpers";
import {
  handleSolution,
  setSolution,
  setSolutionByCallback,
  stompClient
} from "./solution";
import { setApps, setTags } from "./account";
import mixpanelWrapper from "../../utils/mixpanel";

export const setProjectStarted = isStarted => ({
  type: SET_PROJECT_STARTED,
  payload: isStarted
});

export function setProject(obj, checkRoutes) {
  return (dispatch, getState) => {
    if (sessionStorage.currentProject !== obj.id) return;

    if (checkRoutes && obj.solution) {
      const selectedVehicles = getState().project.selectedVehicles;
      const noRoutes = !obj.solution.routes.some(route =>
        selectedVehicles.includes(route.vehicle_id)
      );
      if (noRoutes) {
        dispatch(setExtendableType(null));
        dispatch(setExtendableId(null));
        dispatch(setCurrentWindow("Project"));
      }
    }

    const vehicles = getState().project.vehicles;

    if (obj.solution) {
      obj.solution.routeGroups = getFormattedRoutes(
        obj.solution.routes,
        vehicles
      );
      obj.solution.routeColors = getRouteColors(obj.solution.routeGroups);
    }

    dispatch({
      type: PROJECT,
      obj
    });
  };
}

export function setProjectOptions(obj) {
  return {
    type: PROJECT_OPTIONS,
    obj
  };
}

export function setVehicles(arr) {
  return function (dispatch) {
    dispatch({
      type: SET_VEHICLES,
      arr
    });
  };
}

export function setVehicleTypes(arr) {
  return function (dispatch) {
    dispatch(setVehiclesListLoaded());
    dispatch({
      type: SET_VEHICLE_TYPES,
      arr
    });
  };
}

// Select or deselect vehicle
export function deselectVehicle(id, typeId) {
  return (dispatch, getState) => {
    dispatch(setLoadingProject(true));
    const project = getState().project;
    const vehicles = project.vehicles;

    const extendableId = getState().extendable.id;
    const extendableType = getState().extendable.type;

    let selected = project.selectedVehicles;
    console.log(1, selected);

    selected = selected.filter(el => el !== id);
    console.log(2, selected);
    API.post(`/v1/projects/${project.id}/vehicles/${id}?action=selection`)
      .then(res => {
        const newVehicles = vehicles.filter(
          vehicle => vehicle?.type_id?.id !== typeId
        );

        console.log(3, selected);

        if (!selected.length) {
          //change status
          API.patch(`v1/projects/${project.id}/status`, {
            status: "preparing"
          })
            .then(res => {
              const project = getState().project;
              dispatch(setProject({ ...project, status: "preparing" }));
            })
            .catch(error => console.log(error));
        }

        if (extendableType === "vehicles" && extendableId === id) {
          dispatch(setExtendableType(null));
          dispatch(setExtendableId(null));
        }

        dispatch(setVehicles(newVehicles));
        dispatch({
          type: SELECTED_VEHICLES,
          arr: selected
        });
        if (project.solution) {
          const newSolution = { ...project.solution };
          const routesToRemove = newSolution.routes.filter((route, i) => {
            if (route.vehicle_id.split("_")[0] === id) {
              return true;
            }
            return false;
          });
          if (routesToRemove.length) {
            const tasksToUnassign = [];
            const routesToRemoveIds = routesToRemove.map(route => route.id);
            routesToRemove.forEach(route => {
              route.stops.forEach(stop => {
                if (
                  stop.type !== "start" &&
                  stop.type !== "end" &&
                  stop.type !== "break"
                ) {
                  tasksToUnassign.push(stop);
                  return false;
                } else {
                  return true;
                }
              });
            });
            newSolution.routes = newSolution.routes.filter(
              route => !routesToRemoveIds.includes(route.id)
            );
            newSolution.unassigned.stops = [
              ...newSolution.unassigned.stops,
              ...tasksToUnassign
            ];
            dispatch(setSolution(newSolution));
          }
        }
      })
      .catch(err => {
        console.log(err);
        if (!checkFor401(err)) {
          dispatch(
            enqueueSnackbar({
              message: "Something went wrong, please refresh the page"
            })
          );
        }
      })
      .finally(() => {
        dispatch(setLoadingProject(false));
      });
  };
}

export function setSelectedVehicles(arr) {
  return function (dispatch, getState) {
    const selectedVehiclesOld = getState().project.selectedVehicles;
    if (!arraysEqual(arr, selectedVehiclesOld)) {
      dispatch({ type: SELECTED_VEHICLES, arr });
    }
  };
}

export function setChangedVehicles(ids) {
  return (dispatch, getState) => {
    ids = Array.isArray(ids) ? ids : [ids];

    let changedVehicles = getState().project.changedVehicles;

    changedVehicles = Array.from(new Set(changedVehicles.concat(ids)));

    dispatch({
      type: CHANGED_VEHICLES,
      arr: changedVehicles
    });
  };
}

export function clearChangedVehicles() {
  return {
    type: CHANGED_VEHICLES,
    arr: []
  };
}

export function setDrivers(arr) {
  return function (dispatch) {
    dispatch(setDriversListLoaded());
    dispatch({
      type: SET_DRIVERS,
      arr
    });
  };
}

export function setDriverLocations(obj) {
  return {
    type: SET_DRIVER_LOCATIONS,
    obj
  };
}

export function setDriversLiveStatus(payload) {
  return {
    type: SET_DRIVER_LIVE,
    payload
  };
}

export function clearDriverLocations(obj) {
  return {
    type: CLEAR_DRIVER_LOCATIONS,
    obj
  };
}

let driverLiveTimeout;
// Update driver location
export function updateDriverLocation({ lat, lng, date, route_id, error }) {
  return (dispatch, getState) => {
    const isDriverLiveLocationVisible =
      getState().map?.isDriverLiveLocationVisible;
    if (error) {
      dispatch({
        type: SET_DRIVER_LIVE,
        payload: {
          [route_id]: undefined
        }
      });
    } else {
      dispatch({
        type: SET_DRIVER_LIVE,
        payload: { [route_id]: true }
      });
    }

    if (driverLiveTimeout) {
      clearTimeout(driverLiveTimeout);
    }

    driverLiveTimeout = setTimeout(
      () =>
        dispatch({
          type: SET_DRIVER_LIVE,
          payload: {
            [route_id]: undefined
          }
        }),
      1000 * 30 * 60
    );
    // }
    if (isDriverLiveLocationVisible) {
      dispatch(
        setDriverLocations({
          [route_id]: {
            lat,
            lng,
            date
          }
        })
      );
    }
  };
}

// For better performance the driverLocation should listen for all socket updates but update only one time for every minute;
export function batchUpdateDriversLiveStatuses(liveStatuses) {
  return (dispatch, getState) => {
    const allLiveStatuses = {
      ...liveStatuses.active,
      ...liveStatuses.inactive
    };
    dispatch(setDriversLiveStatus(allLiveStatuses));

    if (driverLiveTimeout) {
      clearTimeout(driverLiveTimeout);
    }

    driverLiveTimeout = setTimeout(
      () => dispatch(setDriversLiveStatus(liveStatuses.active)),
      1000 * 30 * 60
    );
  };
}

export function batchUpdateDriversLocations(driversLocations) {
  return (dispatch, getState) => dispatch(setDriverLocations(driversLocations));
}

export function setImported(valid, invalid, import_type) {
  return {
    type: IMPORT_SERVICES,
    valid,
    invalid,
    import_type
  };
}

export function setSelectedRoutes(arr) {
  return {
    type: SELECTED_ROUTES,
    arr
  };
}

export function toggleRouteSelectedStatus(id) {
  return function (dispatch, getState) {
    const routeGroups = getState().project.solution.routeGroups;
    let backhaulGroup;
    Object.keys(routeGroups).find(key => {
      const routes = routeGroups[key].find(backhaulGroup =>
        backhaulGroup.find(route => route.id === id)
      );
      if (routes) {
        backhaulGroup = routes.map(route => route.id);
        return true;
      } else {
        return false;
      }
    });

    const selectedRoutes = getState().common.selectedRoutes;
    if (selectedRoutes.includes(id)) {
      dispatch(
        setSelectedRoutes(
          selectedRoutes.filter(routeId => !backhaulGroup.includes(routeId))
        )
      );
    } else {
      dispatch(setSelectedRoutes([...selectedRoutes, ...backhaulGroup]));
    }
  };
}

export function setLockedRoutes(obj) {
  return function (dispatch, getState) {
    const dragSelection = getState().common.dragSelection;
    if (obj[dragSelection.listId.slice(6)]) {
      dispatch(setDragSelection(""));
    }

    // make request

    dispatch({
      type: LOCKED_ROUTES,
      obj
    });
  };
}

export function setExpandedRoutes(arr) {
  return {
    type: EXPANDED_ROUTES,
    arr
  };
}

export function setExpandedFromMap(bool) {
  return {
    type: EXPANDED_FROM_MAP,
    bool
  };
}

export function toggleRouteExpandedStatus(id) {
  return function (dispatch, getState) {
    const expandedRoutes = getState().common.expandedRoutes;
    const expandedFromMap = getState().common.expandedFromMap;
    if (expandedFromMap) {
      dispatch(setExpandedFromMap(false));
    }
    if (expandedRoutes.includes(id)) {
      dispatch(setExpandedRoutes(expandedRoutes.filter(el => el !== id)));
    } else {
      dispatch(setExpandedRoutes([...expandedRoutes, id]));
    }
  };
}

export function setPublicationSettings(obj) {
  return {
    type: PUBLICATION_SETTINGS,
    obj
  };
}

// Optimize with PUT vehicles
export function postOptimize(action_name, callback) {
  return (dispatch, getState) => {
    const { project } = getState();
    const { vehicles, selectedVehicles } = project;
    const optimizeSetings = {
      optimize_unassigned_stops: true,
      optimize_started_routes: false
    };
    const data = {};
    dispatch(setLoadingProject(true));
    dispatch(setExtendableType(null));
    dispatch(setExtendableId(null));
    dispatch(setExpandedRoutes([]));

    let routesList = document.getElementById("routes-list");
    if (routesList) routesList.scrollTop = 0;

    vehicles
      .filter(vehicle => selectedVehicles.includes(vehicle.vehicle_id))
      .forEach(vehicle => {
        if (vehicle?.type_id) {
          !data[vehicle?.type_id] && (data[vehicle?.type_id] = []);

          data[vehicle?.type_id].push(vehicle.vehicle_id);
        }
      });

    if (action_name === "not_optimize_unassigned_stops") {
      optimizeSetings.optimize_unassigned_stops = false;
    }

    if (action_name === "reoptimize_all_routes") {
      optimizeSetings.optimize_started_routes = true;
    }

    if (action_name === "reoptimize_all_routes_without_unscheduled") {
      optimizeSetings.optimize_started_routes = true;
      optimizeSetings.optimize_unassigned_stops = false;
    }

    if (action_name === "reoptimize_full") {
      optimizeSetings.optimize_unassigned_stops = true;
      optimizeSetings.optimize_started_routes = true;
    }

    if (action_name === "Optimize") {
      mixpanelWrapper.track("Project Optimize", {
        Stops: project.vrp.stops.length,
        Vehicles: project.selectedVehicles.length,
        "Project ID": project.id
      });
    }

    // POST VRP for Optimization
    API.post(`/v1/projects/${project.id}/optimize`, optimizeSetings)
      .then(res => {
        dispatch(setSolutionByCallback(project.id, true, undefined, callback));
      })
      .catch(error => {
        if (error && error.data && error.data.status === 400) {
          dispatch(
            setInfoDialog({
              visible: true,
              title: "Operation not possible",
              body: error.data.message
            })
          );
          dispatch(setLoadingProject(false));
        } else {
          if (!checkFor401(error)) {
            dispatch(enqueueSnackbar({ message: "Something went wrong" }));
            dispatch(setLoadingProject(false));
          }
        }
        console.log(error);
      });
  };
}

// Reoptimize selected routes
export function reoptimizeRoutes(routesList, reoptimizeConfig = {}) {
  return (dispatch, getState) => {
    const project = getState().project;
    const selectedRoutes = getState().common.selectedRoutes;

    dispatch(setLoadingProject(true));
    API.patch(`/v1/projects/${project.id}/routes/reoptimize`, {
      routes_id: routesList || selectedRoutes,
      ...reoptimizeConfig
    })
      .then(res => {
        dispatch(setSolutionByCallback(project.id, true));
      })
      .catch(error => {
        console.log(error);
        if (error && error.data && error.data.status === 400) {
          dispatch(
            setInfoDialog({
              visible: true,
              title: "Operation not possible",
              body: error.data.message
            })
          );
        }
        dispatch(setLoadingProject(false));
      });
  };
}

export function setCurrentWindow(currentWindow) {
  return function (dispatch) {
    dispatch({ type: SET_CURRENT_WINDOW, val: currentWindow });
  };
}

let wrongSolutionNotified = false;

// Get Project, Vehicles and Vehicle Types
export function getProjectDetails(projectId, setSolution) {
  return async function (dispatch, getState) {
    dispatch(resetProject());
    dispatch(setLoadingProject(true));
    dispatch(setInitialProjectLoading(true));

    let vehiclesOk = true;

    console.log(projectId);

    // Get vehicles
    const url = !projectId ? "" : `/v1/projects/${projectId}/vehicles`;

    console.log(projectId);
    const handleVehicles = data => {
      dispatch(setVehicles(data));

      // Set selected vehicles
      const selectedVehicles = data
        .filter(vehicle => vehicle.selected)
        .map(vehicle => vehicle.vehicle_id);

      dispatch(setSelectedVehicles(selectedVehicles));
    };

    url &&
      (await API.get(url)
        .then(res => {
          handleVehicles(res.data);
        })
        .catch(err => {
          if (err && err.data.status === 404) {
            const notes = getState().snackbar.notifications;
            if (
              !notes ||
              (!notes.find(note => note.message === "No user found") &&
                url !== "/v1/vehicles")
            ) {
              dispatch(
                enqueueSnackbar({
                  message: "Project not found."
                })
              );
            }
            vehiclesOk = false;
            sessionStorage.removeItem("currentProject");
            dispatch(setLoadingProject(false));
            dispatch(setInitialProjectLoading(false));
            history.push("/");
          } else {
            vehiclesOk = false;
            if (!checkFor401(err)) {
              dispatch(
                enqueueSnackbar({
                  message: "Something went wrong while fetching vehicles."
                })
              );
              sessionStorage.removeItem("currentProject");
              history.replace("/");
            }
          }
          console.log(err);
        }));

    Promise.all([
      API.get("/v1/vehicles"),
      API.get("/v1/drivers"),
      projectId && vehiclesOk ? API.get(`/v1/projects/${projectId}`) : "",
      API.get("/v1/tags"),
      API.get("/v1/templates"),
      projectId && vehiclesOk
        ? API.get(`/v1/projects/${projectId}/solutions`)
        : ""
    ])
      .then(res => {
        dispatch(setVehicleTypes(res[0].data));
        if (res[3].data) dispatch(setTags(res[3].data));
        if (res[1].data) dispatch(setDrivers(res[1].data));
        const newProject = res[2].data ? { ...res[2].data } : null;

        if (newProject) {
          const solution = newProject.solution;
          if (solution && solution.status === "FINISHED" && solution.routes) {
            const isWrongRoute = solution.routes.some(
              route => !route.stops.length
            );
            if (isWrongRoute) {
              sessionStorage.removeItem("currentProject");
              dispatch(resetProject());
              history.push("/");
              !wrongSolutionNotified &&
                dispatch(
                  enqueueSnackbar({
                    message:
                      "Something went wrong, the project is damaged, please contact to us."
                  })
                );
              wrongSolutionNotified = true;
              return;
            }
          }
          dispatch(setProject(newProject));

          if (!newProject.publication_settings) {
            dispatch(
              enqueueSnackbar({ message: "Couldn't get publication settings" })
            );
          }
          if (setSolution && projectId && newProject.solution) {
            if (newProject.solution.status !== "FINISHED") {
              dispatch(
                setSolutionByCallback(projectId, false, {
                  initialLoading: newProject.solution.status
                })
              );
            } else {
              dispatch(
                handleSolution(newProject.solution, false, {
                  initialLoading: newProject.solution.status
                })
              );
            }
          } else {
            const realSolution = res[5].data;
            if (realSolution.status !== "ERROR") {
              dispatch(setInitialProjectLoading(false));
              dispatch(setCurrentWindow("Project"));
              dispatch(
                setSolutionByCallback(projectId, false, {
                  initialLoading: false
                })
              );
            } else {
              dispatch(setLoadingProject(false));
              dispatch(setCurrentWindow("Project"));
              dispatch(setInitialProjectLoading(false));
            }
          }
          if (
            newProject.solution &&
            newProject.solution.unassigned.stops.length &&
            !["published", "preparing", "expired", "finished"].includes(
              newProject.status.toLowerCase()
            ) &&
            newProject.id === sessionStorage.currentProject
          ) {
            // dispatch(setExtendableType("unscheduled"));
          } else {
            dispatch(setExtendableType(null));
          }
        } else {
          dispatch(setLoadingProject(false));
          dispatch(setInitialProjectLoading(false));
        }
        mixpanelWrapper.people.set({
          "Fleet Size": res[0].data.length,
          Drivers: res[1].data.length,
          "Notification Active": res[4].data.some(
            notification => notification.is_enable === true
          )
        });
      })
      .catch(err => {
        console.log(err);
        if (!checkFor401(err)) {
          dispatch(setLoadingProject(false));
          dispatch(setInitialProjectLoading(false));
          const notes = getState().snackbar.notifications;
          if (!notes || !notes.find(note => note.message === "No user found")) {
            dispatch(
              enqueueSnackbar({
                message:
                  "Something went wrong, failed to get some details for the project."
              })
            );
          }
          sessionStorage.removeItem("currentProject");
          history.replace("/");
        }
      })
      .finally(() => {});

    API.get("/v1/apps")
      .then(res => {
        if (res.data) dispatch(setApps(res.data));
      })
      .catch(err => {
        if (!err || !err.message?.includes("Subscription")) {
          enqueueSnackbar({
            message:
              "Something went wrong, failed to get some details for the project."
          });
        }
      });
  };
}

// Delete all stops
export function deleteAllStops() {
  return (dispatch, getState) => {
    const project = getState().project;

    dispatch(setLoadingProject(true));
    dispatch(setExtendableType(null));
    dispatch(setExtendableId(null));
    API.patch(`/v1/projects/${project.id}/clear`)
      .then(res => {
        dispatch(setCurrentWindow("Project"));
        dispatch(setProject(res.data));
        dispatch(
          enqueueSnackbar({
            message: `All stops of "${project.name}" were deleted.`
          })
        );
      })
      .catch(err => {
        console.log(err);
        dispatch(
          enqueueSnackbar({
            message: `Something went wrong, couldn't delete all stops.`
          })
        );
      })
      .finally(() => {
        dispatch(setLoadingProject(false));
      });
  };
}

/**
 *  Set name and date
 */

export const setProjectDetails = (name, date, id) => {
  return {
    type: SET_PROJECT_DETAILS,
    payload: { name, date, id }
  };
};

// Get Project, Vehicles and Vehicle Types
export function silentlyGetSolution(projectId, callback) {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      API.get(`/v1/projects/${projectId}/solutions`)
        .then(res => {
          dispatch(setSolution(res.data));
          callback && callback(undefined, res.data);
          resolve();
        })
        .catch(error => {
          callback && callback(error);
          console.log(error);
          reject();
        });
    });
  };
}

// Update stop details from websocket data
export function updateStopFromWebsocket({
  lat,
  lng,
  date: dateStr,
  status,
  images,
  signature,
  signature_name,
  recipient_date_of_birth,
  completion_note,
  recipient_note,
  service_id,
  route_id,
  ETAs
}) {
  // Location
  return (dispatch, getState) => {
    const driverLocations = getState().map.driverLocations;
    const isDriverLiveLocationVisible =
      getState().map?.isDriverLiveLocationVisible;
    ETAs = ETAs || {};
    if (isDriverLiveLocationVisible) {
      dispatch(
        setDriverLocations({
          [route_id]: {
            lat:
              lat || !driverLocations.route_id
                ? lat
                : driverLocations.route_id.lat,
            lng:
              lng || !driverLocations.route_id
                ? lng
                : driverLocations.route_id.lng,
            date: Date.now()
          }
        })
      );
    }
    if (getState().extendable.id === service_id) {
      dispatch(
        setInfoDialog({
          visible: true,
          title: "Driver just completed this task",
          mainButtonText: "Close",
          body: "You cannot edit it anymore."
        })
      );
    }

    const { solution, published_once } = getState().project;
    const newSolution = { ...solution };
    const routeIndex = newSolution.routes.findIndex(el => el.id === route_id);

    if (routeIndex !== -1) {
      const stopIndex = newSolution.routes[routeIndex].stops.findIndex(
        el => el.id === service_id
      );

      const stop = newSolution.routes[routeIndex].stops[stopIndex];

      const date = new Date(dateStr);
      const secondsTime = date.getHours() * 3600 + date.getMinutes() * 60;
      Object.keys(ETAs).forEach(recalculatedRouteId => {
        const recalculatedRouteIndex = newSolution.routes.findIndex(
          route => route.id === recalculatedRouteId
        );

        newSolution.routes[recalculatedRouteIndex] = {
          ...newSolution.routes[recalculatedRouteIndex],
          stops: newSolution.routes[recalculatedRouteIndex].stops.map(
            (task, i) => {
              const recalculatedRouteETAs = ETAs[recalculatedRouteId];

              if (i === stopIndex && recalculatedRouteIndex === routeIndex) {
                return {
                  ...stop,
                  finish_time: secondsTime,
                  finish_time_string: dateStr,
                  status,
                  images,
                  signature,
                  signature_name,
                  age_verified: !!recipient_date_of_birth,
                  recipient_date_of_birth,
                  completion_note,
                  recipient_note,
                  finish_address: {
                    ...stop.finish_address,
                    lat,
                    lng
                  },
                  arr_time: recalculatedRouteETAs[task.id] || task.arr_time
                };
              } else {
                return {
                  ...task,
                  arr_time: recalculatedRouteETAs[task.id] || task.arr_time
                };
              }
            }
          )
        };
      });
      const isAllStopsFinished = newSolution.routes
        .filter(route => route.selected && route.stops.length > 2)
        .every(route => route.stops.every(stop => stop.status === "finished"));
      if (isAllStopsFinished) {
        //Upadte project status when all stops is completed EN-2019!
        const newProject = getState().project;
        dispatch(
          setProject({
            ...newProject,
            solution: newSolution,
            status: "finished"
          })
        );
      } else {
        published_once && dispatch(setSolution(newSolution));
      }
    }
  };
}

// Track D: apply live-recomputed ETAs relayed from the driver app over the live WS (no service change).
// Lightweight sibling of updateStopFromWebsocket — applies only arr_time via the identity-preserving
// UPDATE_ROUTES_ETAS reducer (no setSolution / getFormattedRoutes rebuild), so the route list stays smooth.
export function updateEtasFromWebsocket({ ETAs }) {
  return (dispatch, getState) => {
    if (!ETAs || !Object.keys(ETAs).length) return;
    const { published_once } = getState().project;
    if (!published_once) return;
    dispatch({ type: UPDATE_ROUTES_ETAS, ETAs });
  };
}

export const setShowingRouteId = routeId => dispatch => {
  dispatch({
    type: SET_SHOWING_ROUTE_ID,
    payload: { routeId }
  });
};

export const resetProject = id => dispatch => {
  stompClient && stompClient.disconnect();
  setDeterminateLoading({
    loading: false,
    percent: 0,
    status: ""
  });
  dispatch({
    type: RESET_STATE,
    id
  });
};
